import React from 'react';
import { TeamChat } from './communication/CommunicationHub';
import './communication/Communication.css';
import './communication/QLFConecta.css';
import './communication/QLFConectaResponsive.css';

export default function QLFConecta() {
  return <div className="communication-hub qlf-connecta-workspace"><TeamChat /></div>;
}
